import { defineEffect } from '../../../core/effect';
import { newPhaseSpec } from '../fx/newPhase';

/** フェイズの切り替え（鋼の板と名前）（Issue #589。状況は共通側の `editorPorts/duelSituations/new_phase.js` が決め、絵の組み立ては `../fx/newPhase.js`） */
export default defineEffect({ situation: 'new_phase_other', role: 'effect', ...newPhaseSpec(false) }, 'new_phase_other_effect.js');
